import { DEFAULT_NAME } from '@/constants';
import { useState } from 'react';

export default () => {
  const [name, setName] = useState<string>(DEFAULT_NAME);
  const [addSquareModal, setAddSquareModal] = useState<boolean>(false);
  return {
    name,
    setName,
    addSquareModal,
    setAddSquareModal,
  };
};
